import { Link } from 'react-router-dom';
import { comics } from '@/mocks/comics';

export default function LatestUpdatesSection() {
  const latestComics = comics
    .sort((a, b) => new Date(b.updatedAt).getTime() - new Date(a.updatedAt).getTime())
    .slice(0, 8);

  const formatDate = (dateStr: string) => {
    const d = new Date(dateStr);
    const m = d.getMonth() + 1;
    const day = d.getDate();
    return `${m}月${day}日`;
  };

  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-2">
            最新更新
          </h2>
          <p className="text-sm text-foreground-500">同步韩国最新连载，每日不容错过</p>
        </div>

        <div className="bg-background-50 rounded-xl border border-background-200/70 overflow-hidden">
          {latestComics.map((comic, idx) => {
            const latest = comic.chapters[0];
            return (
              <Link
                key={comic.id}
                to={`/comic/${comic.id}`}
                className={`flex items-center gap-4 px-4 md:px-6 py-4 hover:bg-background-100 transition-colors cursor-pointer ${
                  idx < latestComics.length - 1 ? 'border-b border-background-200/70' : ''
                }`}
              >
                <div className="flex-shrink-0 w-12 h-16 md:w-14 md:h-20 rounded-md overflow-hidden">
                  <img
                    src={comic.cover}
                    alt={comic.title}
                    className="w-full h-full object-cover object-top"
                  />
                </div>

                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2 mb-1">
                    <h3 className="text-sm md:text-base font-semibold text-foreground-950 truncate">
                      {comic.title}
                    </h3>
                    <span className={`text-[10px] px-1.5 py-0.5 rounded whitespace-nowrap ${
                      comic.status === '已完结'
                        ? 'bg-accent-100 text-accent-700'
                        : 'bg-primary-100 text-primary-700'
                    }`}>
                      {comic.status}
                    </span>
                  </div>
                  <div className="flex items-center gap-3 text-xs text-foreground-400">
                    <span>{comic.author}</span>
                    <span className="w-1 h-1 rounded-full bg-foreground-300"></span>
                    <span>{comic.rating} 分</span>
                  </div>
                </div>

                <div className="flex-shrink-0 text-right hidden sm:block">
                  <div className="text-sm font-medium text-primary-500 truncate max-w-[180px]">
                    {latest?.title}
                  </div>
                  <div className="text-xs text-foreground-400 mt-0.5">
                    {latest ? formatDate(latest.date) : ''}
                  </div>
                </div>

                <div className="flex-shrink-0 text-foreground-300">
                  <i className="ri-arrow-right-s-line text-xl"></i>
                </div>
              </Link>
            );
          })}
        </div>

        <div className="text-center mt-8">
          <Link
            to="/category/romance"
            className="inline-flex items-center gap-2 text-sm font-medium text-primary-500 hover:text-primary-600 transition-colors whitespace-nowrap cursor-pointer"
          >
            查看更多更新
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}